import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import type { IVideoVisitTests } from "@api/videoVisit/types";
import type { ID } from "@constants";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "video-visit-tests";

type IResponse = AxiosResponse<IApiResponse<IVideoVisitTests>>;
interface IVariables {
  appointmentId: ID;
}

export const getVideoVisitTests: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.get(`video-visit/${params?.appointmentId}/tests`, {
    params,
    signal,
  });
};

export const useVideoVisitTests = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getVideoVisitTests(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
});
